import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NavigationComponent } from "./navigation.component";
import { TranslatorModule } from "app/translator";

@NgModule({
  declarations: [NavigationComponent],
  imports: [CommonModule, RouterModule, TranslatorModule],
  exports: [NavigationComponent],
})
export class NavigationModule {}
